export const CREATE_BOOKING_REQUEST = "CREATE_BOOKING_REQUEST";
export const CREATE_BOOKING_SUCCESS = "CREATE_BOOKING_SUCCESS";
export const CREATE_BOOKING_FAIL = "CREATE_BOOKING_FAIL";
export const CLEAR_ERRORS = "CLEAR_ERRORS";


export const MY_BOOKING_REQUEST  = "MY_BOOKING_REQUEST"
export const MY_BOOKING_SUCCESS  = "MY_BOOKING_SUCCESS"
export const MY_BOOKING_FAIL = "MY_BOOKING_FAIL";


export const BOOKING_DETAILS_REQUEST = "BOOKING_DETAILS_REQUEST";
export const BOOKING_DETAILS_SUCCESS = "BOOKING_DETAILS_SUCCESS";
export const BOOKING_DETAILS_FAIL = "BOOKING_DETAILS_FAIL";


export const ALL_BOOKINGS_REQUEST = "ALL_BOOKINGS_REQUEST";
export const ALL_BOOKINGS_SUCCESS = "ALL_BOOKINGS_SUCCESS";
export const ALL_BOOKINGS_FAIL = "ALL_BOOKINGS_FAIL";

export const UPDATE_BOOKING_REQUEST = "UPDATE_BOOKING_REQUEST";
export const UPDATE_BOOKING_SUCCESS = "UPDATE_BOOKING_SUCCESS";
export const UPDATE_BOOKING_RESET = "UPDATE_BOOKING_RESET";
export const UPDATE_BOOKING_FAIL = "UPDATE_BOOKING_FAIL";


export const DELETE_BOOKING_REQUEST = "DELETE_BOOKING_REQUEST";
export const DELETE_BOOKING_SUCCESS = "DELETE_BOOKING_SUCCESS";
export const DELETE_BOOKING_RESET = "DELETE_BOOKING_RESET";
export const DELETE_BOOKING_FAIL = "DELETE_BOOKING_FAIL";